import QuestionnaireShell from "./QuestionnaireShell";

const sections = [
    {
        title: "Personal Information",
        description: "Basic details to tailor your plan.",
        questions: [
            { id: "age", label: "Age", type: "number" },
            { id: "city", label: "City / State" },
            { id: "occupation", label: "Occupation / Industry" },
            {
                id: "take_home",
                label: "Monthly take-home income (₹)",
                type: "number",
                notes: "After tax, net salary.",
            },
            {
                id: "other_income",
                label: "Other income sources (₹/month)",
                notes: "Freelance, rent, interest, etc.",
            },
        ],
    },
    {
        title: "Debt Overview",
        description: "A snapshot of what you owe.",
        questions: [
            {
                id: "active_loans",
                label: "Number of active loans",
                type: "number",
                notes: "Personal, home, car, education, etc.",
            },
            {
                id: "total_emi",
                label: "Total EMI outflow per month (₹)",
                type: "number",
            },
            {
                id: "credit_cards",
                label: "Number of credit cards used",
                type: "number",
            },
            {
                id: "cc_outstanding",
                label: "Total outstanding credit card balance (₹)",
                type: "number",
            },
            {
                id: "cc_payment_habit",
                label: "Do you pay minimum due, full, or a mix?",
            },
            {
                id: "informal_debt",
                label: "Informal debt to family/friends (₹)",
            },
            {
                id: "missed_emi",
                label: "Missed any EMI in last 6 months?",
                notes: "Yes / No — if yes, how many",
            },
        ],
    },
    {
        title: "Monthly Expenses",
        description: "Rough monthly splits — ballpark is fine.",
        questions: [
            { id: "rent", label: "Rent / Housing (₹)", type: "number" },
            { id: "groceries", label: "Groceries & Household (₹)", type: "number" },
            { id: "transport", label: "Transport / Fuel (₹)", type: "number" },
            {
                id: "insurance",
                label: "Insurance premiums (₹/month)",
                type: "number",
            },
            {
                id: "subscriptions",
                label: "Subscriptions & Memberships (₹)",
            },
            { id: "dining", label: "Dining out / Entertainment (₹)" },
            { id: "education", label: "Children's education (₹)" },
        ],
    },
    {
        title: "Goals & Concerns",
        description: "The most important part — your 'why'.",
        questions: [
            {
                id: "worry",
                label: "Your #1 financial worry right now",
                type: "textarea",
            },
            {
                id: "target_months",
                label: "Target months to be debt-free",
                type: "number",
            },
            {
                id: "lifestyle",
                label: "Willing to make lifestyle changes? (Yes / No / Depends)",
            },
            {
                id: "extra",
                label: "Anything else we should know?",
                type: "textarea",
            },
        ],
    },
];

export default function DishaForm() {
    return (
        <QuestionnaireShell
            title="Disha Questionnaire"
            tagline="Disha · Quick Health Check · ₹969"
            packageKey="disha"
            sections={sections}
        />
    );
}
